var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": _vm.pageTitle,
      "subTitleText": _vm.subText,
      "subTitleTextMdLgXlWidth": _vm.desktopSubTitleWidth,
      "subTitleTextSmXsWidth": _vm.mobileSubTitleWidth
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: _vm.route
      }
    }
  }, [_c('v-btn', {
    staticClass: "my-4 mb-lg-0 mb-xl-0",
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(_vm._s(_vm.backButtonText))])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }